import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { voteWindowOpen } from "./VoteHeart";

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const SHOWCASE_URL = "https://app.emergent.sh/showcase/builderfest-kevin/0b16bd18-9520-4bb0-a9e9-4e9f475e98b9";
const DISMISS_KEY = "eviq.vote_nudge_done";

/**
 * VoteNudge — one-time contest banner per device.
 * Hidden forever on this device once the visitor votes (here or via the
 * header heart) or dismisses it (localStorage flag).
 */
export const VoteNudge = ({ offsetClass = "bottom-4" }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!voteWindowOpen()) return;
    try { if (window.localStorage.getItem(DISMISS_KEY)) return; } catch { /* noop */ }
    const t = setTimeout(() => setShow(true), 4000);
    return () => clearTimeout(t);
  }, []);

  const done = () => {
    try { window.localStorage.setItem(DISMISS_KEY, "1"); } catch { /* noop */ }
    setShow(false);
  };

  const vote = async () => {
    window.open(SHOWCASE_URL, "_blank", "noopener,noreferrer");
    toast("❤️ Almost there — tap the heart on the contest page to cast your official vote!");
    try { await fetch(`${API_BASE}/api/vote`, { method: "POST" }); } catch { /* noop */ }
    done();
  };

  if (!show) return null;
  return (
    <div
      className={`fixed ${offsetClass} left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 rounded-full border pl-4 pr-2 py-2 shadow-2xl backdrop-blur-xl animate-in fade-in slide-in-from-bottom-4`}
      style={{ borderColor: "rgba(255,75,110,0.4)", background: "rgba(10,6,8,0.92)", maxWidth: "94vw" }}
      data-testid="vote-nudge"
      role="status"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="#FF4B6E" className="shrink-0 animate-pulse" aria-hidden="true">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      </svg>
      <span className="text-[13px] text-white whitespace-nowrap">
        Help EVIQ win — <span className="text-zinc-400">vote takes 5 seconds</span>
      </span>
      <button
        type="button"
        onClick={vote}
        data-testid="vote-nudge-cta"
        className="rounded-full px-4 py-1.5 text-[12px] font-semibold whitespace-nowrap transition-transform hover:scale-[1.04]"
        style={{ background: "#FF4B6E", color: "#fff" }}
      >
        Vote now
      </button>
      <button
        type="button"
        onClick={done}
        data-testid="vote-nudge-dismiss"
        aria-label="Dismiss"
        className="p-1.5 text-zinc-500 hover:text-white transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
